import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material';
import { Component, Inject, OnInit } from '@angular/core';

@Component({
  selector: 'app-dialog-result-confirm',
  templateUrl: './dialog-result-confirm.component.html',
  styleUrls: ['./dialog-result-confirm.component.scss']
})
export class DialogResultConfirmComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<DialogResultConfirmComponent>,
              @Inject(MAT_DIALOG_DATA) public data: {}) {

    console.log(data)
  }

  ngOnInit() {}

  onNoClick(): void {
    this.dialogRef.close();
  }
}



// WEBPACK FOOTER //
// ./src/app/remote/game/dialog-result-confirm/dialog-result-confirm.component.ts